import {Action} from '@ngrx/store';

export class LoginAction implements Action {
  public static readonly type = 'LoginAction';

  constructor(public email: string, public password: string) {
  }

  public type = LoginAction.type;
}
